import { UtilityComponentDef } from "@flow/common/utility_component_def";
import { error } from "@flow/lib/error";

export interface UtilityComponent {
  def: UtilityComponentDef;

  widget: React.FunctionComponent<{}>;
}

const utilityComponents: UtilityComponent[] = [];

export function getUtilityComponents(): Readonly<UtilityComponent[]> {
  return utilityComponents;
}

export function registerUtilityComponent(handler: UtilityComponent) {
  if (utilityComponents.map((c) => c.def.provider_unique_id).includes(handler.def.provider_unique_id)) {
    error(`A utility component for provider_unique_id '${handler.def.provider_unique_id}' is already registered`);
  } else {
    utilityComponents.push(handler);
  }
}
